var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeBlueSmallcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04571 12.8509V10.7525C5.0457 10.2208 5.47809 9.7888 6.01367 9.78546H7.98021C8.51818 9.78546 8.95429 10.2184 8.95429 10.7525V12.8448C8.95428 13.306 9.32907 13.6808 9.79359 13.6842H11.1353C11.7619 13.6858 12.3634 13.4398 12.807 13.0005C13.2507 12.5612 13.5 11.9646 13.5 11.3425V5.3819C13.5 4.87937 13.2756 4.4027 12.8874 4.08029L8.32941 0.461342C7.53267 -0.171653 6.39473 -0.151205 5.62158 0.51L1.16164 4.08029C0.755033 4.39319 0.512009 4.87128 0.5 5.3819V11.3364C0.5 12.6331 1.55873 13.6842 2.86475 13.6842H4.17578C4.39943 13.6858 4.61449 13.5987 4.77322 13.4423C4.93195 13.2858 5.02121 13.073 5.02121 12.8509H5.04571Z",
    fill: "#03002F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeBlueSmallcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/homeBlueSmallcon.f8de37dbff811aa6e1bb89c6624161fc.svg";